import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { mcPromotion } from '@/services';
import {
	listPromotionsSuccess,
	listPromotionsError,
	savePromotionSuccess,
	savePromotionError,
	deletePromotionSuccess,
	deletePromotionError,
} from '../actions';
import {
	PROMOTION_LIST,
	PROMOTION_SAVE,
	PROMOTION_DELETE,
} from '../actions-registry';

function* listPromotionsSaga({ payload }) {
	const { merchantId, menuVersionId, branchId, onError } = payload;
	try {
		const resp = yield call(mcPromotion.list, merchantId, {
			menuVersionId,
			branchId,
		});
		yield put(listPromotionsSuccess(resp?.recordList ?? []));
	} catch (error) {
		yield put(listPromotionsError(error.message));
		if (onError) onError(error);
	}
}

export function* watchListPromotions() {
	yield takeEvery(PROMOTION_LIST, listPromotionsSaga);
}

function* savePromotionSaga({ payload }) {
	const { merchantId, isEdit, promotionCode, request, onSuccess, onError } =
		payload;
	try {
		if (isEdit) {
			yield call(mcPromotion.update, merchantId, promotionCode, request);
		} else {
			yield call(mcPromotion.create, merchantId, request);
		}
		yield put(savePromotionSuccess());
		if (onSuccess) onSuccess();
	} catch (error) {
		yield put(savePromotionError(error.message));
		if (onError) onError(error);
	}
}

export function* watchSavePromotion() {
	yield takeEvery(PROMOTION_SAVE, savePromotionSaga);
}

function* deletePromotionSaga({ payload }) {
	const { merchantId, promotionCode, menuVersionId, onSuccess, onError } =
		payload;
	try {
		yield call(mcPromotion.remove, merchantId, promotionCode, {
			menuVersionId,
		});
		yield put(deletePromotionSuccess());
		if (onSuccess) onSuccess();
	} catch (error) {
		yield put(deletePromotionError(error.message));
		if (onError) onError(error);
	}
}

export function* watchDeletePromotion() {
	yield takeEvery(PROMOTION_DELETE, deletePromotionSaga);
}

export default function* rootSaga() {
	yield all([
		fork(watchListPromotions),
		fork(watchSavePromotion),
		fork(watchDeletePromotion),
	]);
}
